import { type CommonProps, ONBOARDING_EVENTS, trackEvent } from "."

export const common = {
  landOn: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.LAND, props),
  started: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.STARTED, props),
  complete: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.ONBOARDING_COMPLETE, props),
}
